import { useT } from "../../../shared/i18n";
import { Card } from "../../../shared/ui";
import { KeyValueList } from "../KeyValueList";
import { formatDateTime } from "./format";
import type { UserDetailData } from "./usersApi";

export function ProfileSection({ user }: { user: UserDetailData }) {
  const t = useT();
  const byStatus = Object.entries(user.workspaces.by_status)
    .map(([name, count]) => `${name}: ${String(count)}`)
    .join(", ");
  return (
    <Card title={t("admin.users.profile.title")}>
      <KeyValueList
        items={[
          {
            label: "ID",
            value: <span className="font-mono">{user.user_id}</span>,
          },
          {
            label: t("admin.users.profile.status"),
            value: user.profile.status,
          },
          {
            label: t("admin.users.profile.locale"),
            value: user.profile.locale ?? "-",
          },
          {
            label: t("admin.users.profile.timezone"),
            value: user.profile.timezone ?? "-",
          },
          {
            label: t("admin.users.profile.created"),
            value: formatDateTime(user.profile.created_at),
          },
          {
            label: t("admin.users.profile.workspaces"),
            value: byStatus
              ? `${String(user.workspaces.count)} (${byStatus})`
              : String(user.workspaces.count),
          },
          {
            label: t("admin.users.profile.abilities"),
            value: String(user.abilities_count),
          },
        ]}
      />
    </Card>
  );
}
